import { AxiosResponse } from 'axios';
import { ForgotPasswordRequestType, ForgotPasswordResponseType } from './types';
import * as api from '../api';

export const forgotPassword = (
  payload: ForgotPasswordRequestType,
): Promise<AxiosResponse<ForgotPasswordResponseType>> =>
  api.post('/auth/password/recovery', payload);
